import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');

const handleSubmit = async (e: React.FormEvent): Promise<void> => {
  e.preventDefault();
  setError('');

  if (!email || !password) {
    setError('Please fill in all fields');
    return;
  }

  const success = await login(email, password);
  if (success) {
    navigate('/');
  } else {
    setError('Invalid email or password');
  }
};

  return (
    <div style={{
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      padding: '3rem',
      width: '100%',
      maxWidth: '450px',
      margin: '1rem'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          marginBottom: '0.5rem', 
          color: '#1269cc',
          fontWeight: 'bold'
        }}>
          LetShop
        </h1>
        <h2 style={{ 
          fontSize: '1.8rem', 
          marginBottom: '0.5rem', 
          color: '#303030',
          fontWeight: 'bold'
        }}>
          Welcome Back
        </h2>
        <p style={{ 
          color: '#6d9ac7',
        }}>
          Login to your account
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {error && (
          <div style={{
            backgroundColor: '#ffe6e6',
            color: '#d32f2f',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            fontSize: '0.9rem'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '0.5rem',
            color: '#303030',
            fontWeight: '500'
          }}>
            Email
          </label>
          <input 
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            style={{
              width: '100%',
              padding: '0.75rem',
              fontSize: '1rem',
              border: '2px solid #6d9ac7',
              borderRadius: '8px',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#1269cc'}
            onBlur={(e) => e.target.style.borderColor = '#6d9ac7'}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '0.5rem',
            color: '#303030',
            fontWeight: '500'
          }}>
            Password
          </label>
          <input 
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            style={{
              width: '100%',
              padding: '0.75rem',
              fontSize: '1rem',
              border: '2px solid #6d9ac7',
              borderRadius: '8px',
              outline: 'none',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#1269cc'}
            onBlur={(e) => e.target.style.borderColor = '#6d9ac7'}
          />
        </div>

        <button 
          type="submit"
          style={{
            width: '100%',
            backgroundColor: '#1269cc',
            color: '#ffffff',
            border: 'none',
            padding: '1rem',
            fontSize: '1.1rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            marginBottom: '1.5rem',
            transition: 'background-color 0.2s, transform 0.1s'
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0d4f99')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1269cc')}
          onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.98)')}
          onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          Login
        </button>

        <div style={{ 
          textAlign: 'center', 
          paddingTop: '1.5rem',
          borderTop: '1px solid #e0e0e0'
        }}>
          <p style={{ color: '#303030', marginBottom: '0.5rem' }}>
            Don't have an account?
          </p>
          <Link 
            to="/register"
            style={{ 
              display: 'inline-block',
              backgroundColor: '#ffffff',
              color: '#1269cc',
              border: '2px solid #1269cc',
              padding: '0.75rem 2rem',
              fontSize: '1rem',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold',
              textDecoration: 'none',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#1269cc';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = '#ffffff';
              e.currentTarget.style.color = '#1269cc';
            }}
          >
            Create Account
          </Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <Link 
            to="/"
            style={{ 
              color: '#6d9ac7', 
              textDecoration: 'none',
              fontSize: '0.9rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem'
            }}
          >
            ← Back to Home
          </Link>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;